module.exports = __webpack_public_path__ + "static/img/nav3.49ed9b1a.png";